import { createContext, useContext } from 'react';

const LayoutListIsPresentationalContext = createContext<boolean>(false);

export default LayoutListIsPresentationalContext;

export type UseIsLayoutListPresentational = () => boolean;
export const useIsLayoutListPresentational: UseIsLayoutListPresentational = () =>
  useContext<boolean>(LayoutListIsPresentationalContext);
